import OverlayLoader from '@formstack/phoenix/components/Loader/OverlayLoader';

import { StyledOverlayLoader, StyledOverlayLoaderContainer } from './StyledOverlayLoader';
import { ILoadingBoundary } from './interface';

export const LoadingBoundary = ({
  isLoading,
  children,
  pageContext,
  transparent = true,
  renderChildren = true,
  component: Component,
  ...props
}: ILoadingBoundary) => {
  const Tag = pageContext ? StyledOverlayLoader : OverlayLoader;
  const BaseComponent = Component ? Component : StyledOverlayLoaderContainer;

  return (
    <BaseComponent {...props}>
      {(!isLoading || renderChildren) && children}
      {isLoading && (
        <Tag
          verticallyCentered={true}
          transparent={transparent}
          dataTest={
            'data-test' in props && props['data-test'] ? `${props['data-test']}-loader` : undefined
          }
        />
      )}
    </BaseComponent>
  );
};
